import React from 'react';
import HealthCard from './HealthCard';
import {
  faHeadSideCough,
  faLungsVirus,
  faTired,
  faHeadSideVirus,
  faUtensils,
  faPoop,
  faBiohazard,
  faIcicles,
  faBed
} from '@fortawesome/free-solid-svg-icons';

function HealthSymptoms() {
  // TODO: find more icons that match
  return (
    <>
      {symptomsList.map((symp, index) => (
        <HealthCard
          key={`${symp.name}-symp-${index}`}
          name={symp.name}
          icon={symp.icon}
          size="4x"
        />
      ))}
    </>
  );
}

const symptomsList = [
  {
    name: 'Fever or chills',
    icon: faIcicles
  },
  {
    name: 'Cough',
    icon: faHeadSideCough
  },
  {
    name: 'Shortness of breath or difficulty breathing',
    icon: faLungsVirus
  },
  {
    name: 'Fatigue',
    icon: faTired
  },
  {
    name: 'Muscle or body aches',
    icon: faHeadSideCough
  },
  {
    name: 'Headache',
    icon: faHeadSideVirus
  },
  {
    name: 'New loss of taste or smell',
    icon: faUtensils
  },
  {
    name: 'Sore throat',
    icon: faHeadSideVirus
  },
  {
    name: 'Congestion or runny nose',
    icon: faHeadSideVirus
  },
  {
    name: 'Nausea or vomiting',
    icon: faBiohazard
  },
  {
    name: 'Inability to wake or stay awake',
    icon: faBed
  },
  {
    name: 'Diarrhea',
    icon: faPoop
  }
];

export default HealthSymptoms;
